const eventData = [
    {
        id: "1",
        title: "Wood World for International Decorations",
        mainImage: "https://aqaba-seasons.com/events/Wood%20World%20for%20International%20Decorations/1%20(2).JPG",
        images: [
            "https://aqaba-seasons.com/events/Wood%20World%20for%20International%20Decorations/1%20(1).JPG",
            "https://aqaba-seasons.com/events/Wood%20World%20for%20International%20Decorations/1%20(2).JPG",
            "https://aqaba-seasons.com/events/Wood%20World%20for%20International%20Decorations/1%20(3).JPG",
            "https://aqaba-seasons.com/events/Wood%20World%20for%20International%20Decorations/1%20(4).JPG",
            "https://aqaba-seasons.com/events/Wood%20World%20for%20International%20Decorations/1%20(5).JPG",
            "https://aqaba-seasons.com/events/Wood%20World%20for%20International%20Decorations/1%20(6).JPG",
            "https://aqaba-seasons.com/events/Wood%20World%20for%20International%20Decorations/1%20(7).JPG",
            "https://aqaba-seasons.com/events/Wood%20World%20for%20International%20Decorations/1%20(8).JPG",
            "https://aqaba-seasons.com/events/Wood%20World%20for%20International%20Decorations/1%20(9).JPG",
            "https://aqaba-seasons.com/events/Wood%20World%20for%20International%20Decorations/1%20(10).JPG",
            "https://aqaba-seasons.com/events/Wood%20World%20for%20International%20Decorations/1%20(11).JPG",
            "https://aqaba-seasons.com/events/Wood%20World%20for%20International%20Decorations/1%20(12).JPG",
            "https://aqaba-seasons.com/events/Wood%20World%20for%20International%20Decorations/1%20(13).JPG",
            "https://aqaba-seasons.com/events/Wood%20World%20for%20International%20Decorations/1%20(14).JPG",
            "https://aqaba-seasons.com/events/Wood%20World%20for%20International%20Decorations/1%20(15).JPG",
            "https://aqaba-seasons.com/events/Wood%20World%20for%20International%20Decorations/1%20(16).JPG",
            "https://aqaba-seasons.com/events/Wood%20World%20for%20International%20Decorations/1%20(17).JPG",
            "https://aqaba-seasons.com/events/Wood%20World%20for%20International%20Decorations/1%20(18).JPG",
        ]
    },
    {
        id: "2",
        title: "World Underwater Photography Championship in Aqaba",
        mainImage: "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(5).JPG",
        images: [
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(1).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(2).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(3).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(4).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(5).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(6).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(7).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(8).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(9).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(10).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(11).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(12).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(13).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(14).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(15).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(16).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(17).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(18).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(19).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(20).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(21).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(22).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(23).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(24).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(25).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(26).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(27).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(28).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(29).JPG",
            "https://aqaba-seasons.com/events/World%20Underwater%20Photography%20Championship%20in%20Aqaba/1%20(30).JPG",
        ]
    },
    {
        id: "3",
        title: "Model",
        mainImage: "https://aqaba-seasons.com/events/Model/1%20(8).JPG",
        images: [
            "https://aqaba-seasons.com/events/Model/1%20(1).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(2).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(3).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(4).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(5).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(6).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(7).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(8).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(9).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(10).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(11).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(12).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(13).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(14).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(15).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(16).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(17).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(18).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(19).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(20).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(21).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(22).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(23).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(24).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(25).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(26).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(27).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(28).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(29).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(30).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(31).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(32).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(33).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(34).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(35).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(36).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(37).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(38).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(39).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(40).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(41).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(42).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(43).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(44).JPG",
            "https://aqaba-seasons.com/events/Model/1%20(45).JPG",
        ]
    },
    {
        id: "4",
        title: "Graduation",
        mainImage: "https://aqaba-seasons.com/events/Graduation/1%20(9).JPG",
        images: [
            "https://aqaba-seasons.com/events/Graduation/1%20(1).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(2).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(3).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(4).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(5).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(6).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(7).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(8).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(9).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(10).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(11).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(12).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(13).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(14).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(15).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(16).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(17).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(18).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(19).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(20).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(21).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(22).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(23).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(24).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(25).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(26).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(27).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(28).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(29).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(30).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(31).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(32).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(33).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(34).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(35).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(36).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(37).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(38).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(39).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(40).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(41).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(42).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(43).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(44).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(45).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(46).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(47).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(48).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(49).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(50).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(51).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(52).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(53).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(54).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(55).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(56).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(57).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(58).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(59).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(60).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(61).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(62).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(63).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(64).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(65).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(66).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(67).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(68).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(69).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(70).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(71).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(72).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(73).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(74).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(75).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(76).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(77).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(78).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(79).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(80).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(81).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(82).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(83).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(84).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(85).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(86).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(87).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(88).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(89).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(90).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(91).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(92).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(93).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(94).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(95).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(96).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(97).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(98).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(99).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(100).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(101).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(102).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(103).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(104).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(105).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(106).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(107).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(108).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(109).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(110).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(111).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(112).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(113).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(114).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(115).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(116).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(117).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(118).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(119).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(120).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(121).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(122).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(123).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(124).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(125).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(126).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(127).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(128).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(129).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(130).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(131).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(132).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(133).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(134).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(135).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(136).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(137).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(138).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(139).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(140).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(141).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(142).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(143).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(144).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(145).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(146).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(147).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(148).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(149).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(150).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(151).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(152).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(153).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(154).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(155).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(156).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(157).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(158).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(159).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(160).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(161).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(162).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(163).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(164).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(165).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(166).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(167).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(168).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(169).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(170).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(171).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(172).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(173).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(174).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(175).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(176).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(177).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(178).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(179).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(180).JPG",
            "https://aqaba-seasons.com/events/Graduation/1%20(181).JPG"
        ]
    },
    {
        id: "5",
        title: "Independence Day",
        mainImage: "https://aqaba-seasons.com/events/Independence%20Day/1%20(5).JPG",
        images: [
            "https://aqaba-seasons.com/events/Independence%20Day/1%20(1).JPG",
            "https://aqaba-seasons.com/events/Independence%20Day/1%20(2).JPG",
            "https://aqaba-seasons.com/events/Independence%20Day/1%20(3).JPG",
            "https://aqaba-seasons.com/events/Independence%20Day/1%20(4).JPG",
            "https://aqaba-seasons.com/events/Independence%20Day/1%20(5).JPG",
            "https://aqaba-seasons.com/events/Independence%20Day/1%20(6).JPG",
            "https://aqaba-seasons.com/events/Independence%20Day/1%20(7).JPG",
            "https://aqaba-seasons.com/events/Independence%20Day/1%20(8).JPG",
            "https://aqaba-seasons.com/events/Independence%20Day/1%20(9).JPG",
            "https://aqaba-seasons.com/events/Independence%20Day/1%20(10).JPG",
            "https://aqaba-seasons.com/events/Independence%20Day/1%20(11).JPG",
            "https://aqaba-seasons.com/events/Independence%20Day/1%20(12).JPG",
            "https://aqaba-seasons.com/events/Independence%20Day/1%20(13).JPG",
            "https://aqaba-seasons.com/events/Independence%20Day/1%20(14).JPG",
            "https://aqaba-seasons.com/events/Independence%20Day/1%20(15).JPG",
            "https://aqaba-seasons.com/events/Independence%20Day/1%20(16).JPG",
            "https://aqaba-seasons.com/events/Independence%20Day/1%20(17).JPG",
            "https://aqaba-seasons.com/events/Independence%20Day/1%20(18).JPG",
            "https://aqaba-seasons.com/events/Independence%20Day/1%20(19).JPG",
            "https://aqaba-seasons.com/events/Independence%20Day/1%20(20).JPG",
            "https://aqaba-seasons.com/events/Independence%20Day/1%20(21).JPG",
            "https://aqaba-seasons.com/events/Independence%20Day/1%20(22).JPG",
            "https://aqaba-seasons.com/events/Independence%20Day/1%20(23).JPG",
        ]
    },
    {
        id: "6",
        title: "Women's Empowerment Project",
        mainImage: "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(12).JPG",
        images: [
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(1).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(2).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(3).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(4).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(5).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(6).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(7).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(8).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(9).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(10).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(11).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(12).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(13).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(14).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(15).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(16).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(17).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(18).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(19).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(20).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(21).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(22).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(23).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(24).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(25).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(26).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(27).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(28).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(29).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(30).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(31).JPG",
            "https://aqaba-seasons.com/events/Women's%20Empowerment%20Project/1%20(32).JPG",
        ]
    },
    {
        id: "7",
        title: "Sea Marathon",
        mainImage: "https://aqaba-seasons.com/events/Sea%20Marathon/1%20(10).JPG",
        images: [
            "https://aqaba-seasons.com/events/Sea%20Marathon/1%20(1).JPG",
            "https://aqaba-seasons.com/events/Sea%20Marathon/1%20(2).JPG",
            "https://aqaba-seasons.com/events/Sea%20Marathon/1%20(3).JPG",
            "https://aqaba-seasons.com/events/Sea%20Marathon/1%20(4).JPG",
            "https://aqaba-seasons.com/events/Sea%20Marathon/1%20(5).JPG",
            "https://aqaba-seasons.com/events/Sea%20Marathon/1%20(6).JPG",
            "https://aqaba-seasons.com/events/Sea%20Marathon/1%20(7).JPG",
            "https://aqaba-seasons.com/events/Sea%20Marathon/1%20(8).JPG",
            "https://aqaba-seasons.com/events/Sea%20Marathon/1%20(9).JPG",
            "https://aqaba-seasons.com/events/Sea%20Marathon/1%20(10).JPG",
            "https://aqaba-seasons.com/events/Sea%20Marathon/1%20(11).JPG",
            "https://aqaba-seasons.com/events/Sea%20Marathon/1%20(12).JPG",
            "https://aqaba-seasons.com/events/Sea%20Marathon/1%20(13).JPG",
            "https://aqaba-seasons.com/events/Sea%20Marathon/1%20(14).JPG",
            "https://aqaba-seasons.com/events/Sea%20Marathon/1%20(15).JPG",
            "https://aqaba-seasons.com/events/Sea%20Marathon/1%20(16).JPG",
            "https://aqaba-seasons.com/events/Sea%20Marathon/1%20(17).JPG",
            "https://aqaba-seasons.com/events/Sea%20Marathon/1%20(18).JPG",
            "https://aqaba-seasons.com/events/Sea%20Marathon/1%20(19).JPG",
            "https://aqaba-seasons.com/events/Sea%20Marathon/1%20(20).JPG",
            "https://aqaba-seasons.com/events/Sea%20Marathon/1%20(21).JPG",
            "https://aqaba-seasons.com/events/Sea%20Marathon/1%20(22).JPG",
        ]
    },
    {
        id: "8",
        title: "Jordan Summer Festival and Aqaba Nights",
        mainImage: "https://aqaba-seasons.com/events/Jordan%20Summer%20Festival%20and%20Aqaba%20Nights/1%20(10).JPG",
        images: [
            "https://aqaba-seasons.com/events/Jordan%20Summer%20Festival%20and%20Aqaba%20Nights/1%20(1).JPG",
            "https://aqaba-seasons.com/events/Jordan%20Summer%20Festival%20and%20Aqaba%20Nights/1%20(2).JPG",
            "https://aqaba-seasons.com/events/Jordan%20Summer%20Festival%20and%20Aqaba%20Nights/1%20(3).JPG",
            "https://aqaba-seasons.com/events/Jordan%20Summer%20Festival%20and%20Aqaba%20Nights/1%20(4).JPG",
            "https://aqaba-seasons.com/events/Jordan%20Summer%20Festival%20and%20Aqaba%20Nights/1%20(5).JPG",
            "https://aqaba-seasons.com/events/Jordan%20Summer%20Festival%20and%20Aqaba%20Nights/1%20(6).JPG",
            "https://aqaba-seasons.com/events/Jordan%20Summer%20Festival%20and%20Aqaba%20Nights/1%20(7).JPG",
            "https://aqaba-seasons.com/events/Jordan%20Summer%20Festival%20and%20Aqaba%20Nights/1%20(8).JPG",
            "https://aqaba-seasons.com/events/Jordan%20Summer%20Festival%20and%20Aqaba%20Nights/1%20(9).JPG",
            "https://aqaba-seasons.com/events/Jordan%20Summer%20Festival%20and%20Aqaba%20Nights/1%20(10).JPG",
            "https://aqaba-seasons.com/events/Jordan%20Summer%20Festival%20and%20Aqaba%20Nights/1%20(11).JPG",
            "https://aqaba-seasons.com/events/Jordan%20Summer%20Festival%20and%20Aqaba%20Nights/1%20(12).JPG",
            "https://aqaba-seasons.com/events/Jordan%20Summer%20Festival%20and%20Aqaba%20Nights/1%20(13).JPG",
            "https://aqaba-seasons.com/events/Jordan%20Summer%20Festival%20and%20Aqaba%20Nights/1%20(14).JPG",
            "https://aqaba-seasons.com/events/Jordan%20Summer%20Festival%20and%20Aqaba%20Nights/1%20(15).JPG",
            "https://aqaba-seasons.com/events/Jordan%20Summer%20Festival%20and%20Aqaba%20Nights/1%20(16).JPG",
            "https://aqaba-seasons.com/events/Jordan%20Summer%20Festival%20and%20Aqaba%20Nights/1%20(17).JPG",
            "https://aqaba-seasons.com/events/Jordan%20Summer%20Festival%20and%20Aqaba%20Nights/1%20(18).JPG",
            "https://aqaba-seasons.com/events/Jordan%20Summer%20Festival%20and%20Aqaba%20Nights/1%20(19).JPG",
            "https://aqaba-seasons.com/events/Jordan%20Summer%20Festival%20and%20Aqaba%20Nights/1%20(20).JPG",
            "https://aqaba-seasons.com/events/Jordan%20Summer%20Festival%20and%20Aqaba%20Nights/1%20(21).JPG",
            "https://aqaba-seasons.com/events/Jordan%20Summer%20Festival%20and%20Aqaba%20Nights/1%20(22).JPG",
            "https://aqaba-seasons.com/events/Jordan%20Summer%20Festival%20and%20Aqaba%20Nights/1%20(23).JPG",
            "https://aqaba-seasons.com/events/Jordan%20Summer%20Festival%20and%20Aqaba%20Nights/1%20(24).JPG",
            "https://aqaba-seasons.com/events/Jordan%20Summer%20Festival%20and%20Aqaba%20Nights/1%20(25).JPG",
            "https://aqaba-seasons.com/events/Jordan%20Summer%20Festival%20and%20Aqaba%20Nights/1%20(26).JPG",
        ]
    },
    {
        id: "9",
        title: "Tourism Offices to Aqaba",
        mainImage: "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(12).JPG",
        images: [
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(1).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(2).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(3).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(4).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(5).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(6).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(7).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(8).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(9).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(10).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(11).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(12).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(13).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(14).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(15).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(16).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(17).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(18).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(19).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(20).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(21).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(22).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(23).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(24).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(25).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(26).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(27).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(28).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(29).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(30).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(31).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(32).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(33).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(34).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(35).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(36).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(37).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(38).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(39).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(40).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(41).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(42).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(43).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(44).JPG",
            "https://aqaba-seasons.com/events/Tourism%20Offices%20to%20Aqaba/1%20(45).JPG",
        ]
    },
]

export default eventData;